export const planTripCategory = 'plan_trip';
